import BusinessLinesList from './business-lines-list';

export default class BusinessLinesListDesktop extends BusinessLinesList {
	constructor(...args) {
		super(...args);

		this._retrieveDOM();

	}	
	_retrieveDOM() {
		this.dom.images = this.dom.component.querySelectorAll('.js-business-image');
		this.dom.links = this.dom.component.querySelectorAll('.js-business-link');
	}
	bind() {
		super.bind();

		if (this.dom.links) {
			this.dom.links.forEach((link, index) => {
				link.addEventListener('mouseover', () => {		
					for (let i = 0; i < this.dom.images.length; i++) {
						this.dom.images[i].classList.remove('active');
						
					}			
					this.dom.images[index].classList.add('active');
				});
			});
		}
	}
	/*
	init() {
	}
	
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/business-lines-list/business-lines-list.desktop.js